import { EmpathizeLayoutState, EmpathizeState, EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { EMPATHIZE_GETTERS_KEYS } from '../empathize.const';
import { EmpathizeGetter } from '../empathize.interfaces';

export class EmpathizeDetectedStateGetter implements EmpathizeGetter {
  getters = {
    [EMPATHIZE_GETTERS_KEYS.empathizeDetectedState]: (empathizeState: EmpathizeState, getters: any, rootState: RootStoreState,
      rootGetters: any): EmpathizeLayoutState => {
      const config: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      if (this.isIdentifierSearch(config, rootState.core.inputQuery)) {
        return 'identifierSearch';
      } else if (rootState.core.inputQuery.length >= config.empathize.minQueryLength) {
        return 'query';
      } else {
        return 'noQuery';
      }
    }
  };

  protected isIdentifierSearch(config: EmpathyXConfig, query: string): boolean {
    const identifierRegex: RegExp = new RegExp(config.identifierSuggestions.regex.identifierDetection);
    return identifierRegex.test(query);
  }
}
